import React, { useEffect, useContext, useState } from 'react';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { useSelector, useDispatch } from 'react-redux';
import { Footer } from '../../../organisms/FooterComponent';
import { Header } from '../../../organisms/HeaderComponent';
import AccountComponent from '../../../organisms/AccountPage/Container/AccountComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import { getCmsClient } from '../../../common/utilities/cmsClient';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import {
  getHeaderContentData,
  getHeaderData,
  getFooterData,
  isEmptyObject,
  getValueOrnull,
  isMobileDevice,
} from 'common/utilities/utils';
import { ChannelManager } from 'common/manager';
import { UserOrderContext } from 'context/context';
import HEADER_CONSTANT from 'organisms/HeaderComponent/HeaderConstants/HeaderConstant';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import CustomizationAlert from 'organisms/CustomizationAlert/Container/CustomizationAlertContainer';

const AccountContainer = props => {
  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const [showKfcHeader, setShowKfcHeader] = useState(true);

  const dispatch = useDispatch();
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  let segmentedMarketingData = null,
    segmentedHomePageData = null,
    segmentedFooterData = null;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const allReducerData = useSelector(data => {
    return {
      marketPageContent: data.marketConfigReducer.response || null,
      tenantData: data.tenantReducer || null,
      userParams: data.appStateReducer.userStatus || null,
      homePageContent: getValueOrnull(data?.contentReducer?.response),
      tenantReducerContent: getValueOrnull(data?.tenantReducer),
    };
  });

  useEffect(() => {
    userOrderStateDispatch({ type: HEADER_CONSTANT.SET_HIDE_NAV_BARS, value: { flag: !showKfcHeader } });
  }, [showKfcHeader, userOrderStateDispatch]);

  useEffect(() => {
    dispatch(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.location': allReducerData?.tenantData?.country,
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
  }, [allReducerData?.tenantData?.country, dispatch]);

  useEffect(() => {
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.pageType': 'HomePage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams: allReducerData.userParams,
      }),
    );
  }, [allReducerData.userParams, dispatch]);

  if (allReducerData.marketPageContent && allReducerData.tenantData && allReducerData.homePageContent) {
    const { header, footer } = allReducerData.marketPageContent.headerData;
    segmentedMarketingData = getHeaderData(header);
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent);
    segmentedFooterData = getFooterData(footer);
  }

  return (
    <React.Fragment>
      {(isEmptyObject(segmentedMarketingData) && (isMobileDevice(window.innerWidth) ? showKfcHeader : true) && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantData}
          userParams={allReducerData.userParams}
        />
      )) ||
        null}

      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
          contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
        }}
        userParams={userParams}
        showHeader={isMobileDevice(window.innerWidth) ? showKfcHeader : true}
      />

      <AccountComponent history={props.history} setShowKfcHeader={value => setShowKfcHeader(value)} />
      {(isEmptyObject(segmentedFooterData) && (
        <Footer
          history={props.history}
          contentData={segmentedFooterData}
          tenantReducerData={allReducerData.tenantData}
        />
      )) ||
        null}
      {userOrderState.cartAlertData?.showCartAlert && <CustomizationAlert />}
      {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
    </React.Fragment>
  );
};

export default AccountContainer;
